var _defs, _rect, _g, _g2, _rect2, _rect3, _rect4, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeePortalLpPayslips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.37 93.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9aa21;}.cls-2,.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.93px;}.cls-4,.cls-5,.cls-3{opacity:.65;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.76,
    y: 3.86,
    width: 85.85,
    height: 85.85,
    rx: 5.1,
    ry: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m90.5,5.42c1.95,0,3.54,1.59,3.54,3.54v75.64c0,1.95-1.59,3.54-3.54,3.54H14.86c-1.95,0-3.54-1.59-3.54-3.54V8.96c0-1.95,1.59-3.54,3.54-3.54h75.64m0-1.56H14.86c-2.82,0-5.1,2.29-5.1,5.1v75.64c0,2.82,2.29,5.1,5.1,5.1h75.64c2.82,0,5.1-2.29,5.1-5.1V8.96c0-2.82-2.29-5.1-5.1-5.1h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.57,47.66c.34,0,.65.2.76.52.58,1.71,2.02,2.73,4.16,2.73,2.59,0,3.39-1.24,3.39-2.6,0-1.78-1.01-2.62-4.79-3.64-8.41-2.27-10.49-5.44-10.49-9.84,0-5.58,4.66-9.22,11.39-9.22,7.38,0,10.93,3.2,11.68,7.68.08.5-.3.97-.81.97h-6.5c-.37,0-.68-.25-.79-.6-.33-1.09-1.07-2.34-3.53-2.34-2.22,0-2.94,1.25-2.94,2.43,0,1.62,1.03,2.27,5.36,3.47,7.97,2.15,10.08,5.37,10.06,10-.03,6.38-4.98,9.45-12.19,9.45s-11.48-3.38-12.26-8.04c-.08-.51.3-.97.81-.97h6.67Zm1.5-21.02v-2.78c0-.45.37-.82.82-.82h4.45c.45,0,.82.37.82.82v2.78c0,.45-.37.82-.82.82h-4.45c-.45,0-.82-.37-.82-.82Zm.24,32.5v-4.38c0-.45.37-.82.82-.82h4.48c.45,0,.82.37.82.82v4.38c0,.45-.37.82-.82.82h-4.48c-.45,0-.82-.37-.82-.82Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 62.08,
    y: 47.59,
    width: 14.5,
    height: 2.66,
    rx: 1.33,
    ry: 1.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 59.19,
    y: 53.69,
    width: 17.39,
    height: 2.66,
    rx: 1.33,
    ry: 1.33
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.52,
    y: 41.5,
    width: 22.06,
    height: 2.66,
    rx: 1.33,
    ry: 1.33
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "52.1 35.78 81.25 35.78 81.25 69.56 24.12 69.56 24.12 56.04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeePortalLpPayslips);
export default __webpack_public_path__ + "static/media/EmployeePortal LP Payslips.a4c264ec3cb5f8ade048ea96316fab80.svg";
export { ForwardRef as ReactComponent };